import React, { useState, useEffect } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import './BookmarkDetail.css';
import Loading from '../../common/Loading';

function BookmarkDetail() {
  const { section, bookmarkName } = useParams();
  const [bookmark, setBookmark] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    fetch(`https://api.mutantbutton2.com/public/bookmarks/${section}/${bookmarkName}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Bookmark not found');
        }
        return response.json();
      })
      .then(data => {
        setBookmark(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching bookmark:', error);
        setError(error.message);
        setLoading(false);
      });
  }, [section, bookmarkName]);

  if (loading) {
    return <div className="bookmark-detail"><Loading /></div>;
  }

  if (error) {
    return <div className="bookmark-detail error">Error: {error}</div>;
  }

  if (!bookmark) {
    return <div className="bookmark-detail">Bookmark not found</div>;
  }

  return (
    <div className="bookmark-detail">
      <nav className="breadcrumb">
        <NavLink to="/">Home</NavLink>
        <span className="separator">></span>
        <NavLink to="/bookmarks">Bookmarks</NavLink>
        <span className="separator">></span>
        <span className="section">{bookmark.section}</span>
        <span className="separator">></span>
        <span className="current">{bookmark.name}</span>
      </nav>

      <div className="bookmark-header">
        <span className="bookmark-section-tag">#{bookmark.section}</span>
        {bookmark.last_updated && (
          <span className="bookmark-updated">
            Last updated: {new Date(bookmark.last_updated).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
        )}
      </div>
      
      <div className="bookmark-content">
        <ReactMarkdown>{bookmark.content}</ReactMarkdown>
      </div>
    </div>
  );
}

export default BookmarkDetail;
